/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_NewInputs */

const cs_settings_venues_new = /** @type {(inputs: Settings_Venues_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová pobočka`)
};

const en_settings_venues_new = /** @type {(inputs: Settings_Venues_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New office`)
};

/**
* | output |
* | --- |
* | "New office" |
*
* @param {Settings_Venues_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_new = /** @type {((inputs?: Settings_Venues_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_new(inputs)
	return cs_settings_venues_new(inputs)
});